import React, { Component } from "react";
export default class Footer extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <footer id="footer">
        <div className="row">
          <div className="twelve columns">
            <ul className="social">
              {resumeData.socialLinks &&
                resumeData.socialLinks.map((item) => {
                  return (
                    <li key={item.name}>
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <i className={item.className} />
                      </a>
                    </li>
                  );
                })}
            </ul>
            <div className="row">
              <div className="columns contact-details">
                <div className="address">
                  {resumeData.contact.map((v) => (
                    <div key={v.name}>
                      <span>
                        <i className={v.className} />
                        &nbsp;&nbsp;
                        {v.value}
                      </span>
                      <br />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div id="go-top">
            <a className="smoothscroll" title="Back to Top" href="#home">
              <i className="icon-up-open" />
            </a>
          </div>
        </div>
      </footer>
    );
  }
}
